import React, { useEffect, useRef, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { classNames } from "@ct-react/core";
import { AccommodationType } from "@shared/models/article";
import { globalTranslations } from "../../i18n/sharable-defs";
import { AnySearchInput } from "../../models/search";
import "./search-name-filter.scss";

const transDefs = defineMessages({
  search: { id: "search-name-label", defaultMessage: "Rechercher par nom" },
  searched: { id: "search-name-format", defaultMessage: "Recherché par nom ({val})" },
  placeholder: { id: "search-name-placeholder", defaultMessage: "Nom" }
});

type Props = {
  className?: string;
  type: AccommodationType;
  data: AnySearchInput;
  onChange?: (value: { type: AccommodationType, criteria: AnySearchInput }) => void
}
const SearchNameFilter = (
  {
    className,
    type,
    data,
    onChange = () => void 0
  }: Props) => {

  const intl = useIntl();
  const [ inputCount, setInputCount ] = useState<number>(0);
  const activatorRef = useRef<HTMLInputElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setInputCount(data.name?.length || 0);
  }, [ data.name ]);


  // dom interactions

  const onActivation = () => {
    if (!activatorRef.current) return;
    activatorRef.current.checked = true;
    inputRef.current?.focus();
  };

  const onApply = () => {
    onChange({ type, criteria: { ...data, name: inputRef.current?.value || undefined } });
    onCancel();
  }

  const onCancel = (cleaning: boolean = false) => {
    if (cleaning) {
      const { name, ...criteria } = data;
      onChange({ type, criteria });
      if (!!inputRef.current) inputRef.current.value = "";
    }
    if (!activatorRef.current) return;
    activatorRef.current.checked = false;
  }


  // rendering

  const wrapperClasses = classNames("search-filter-name", className);

  return (
    <div className={wrapperClasses}>
      <input ref={activatorRef}
             type="checkbox"
             className="activator" />
      <div className="label">
        {!!data.name
          ? <>
            {intl.formatMessage(transDefs.searched, { val: data.name })}
            <button className="bordered"
                    onClick={() => onActivation()}>
              {intl.formatMessage(globalTranslations.modify)}
            </button>
          </>
          : <button className="bordered"
                    onClick={() => onActivation()}>
            {intl.formatMessage(transDefs.search)}
          </button>
        }
      </div>
      <div className="selector">
        <input ref={inputRef}
               type="text"
               className="input-block"
               placeholder={intl.formatMessage(transDefs.placeholder)}
               defaultValue={data?.name || ""}
               onChange={e => setInputCount(e.target.value.length)} />
        <button type="button"
                className="btn-red"
                disabled={inputCount <= 2}
                onClick={() => onApply()}>
          {intl.formatMessage(globalTranslations.filter)}
        </button>
        <button type="button"
                className="btn-red inverted"
                onClick={() => onCancel(true)}>
          {intl.formatMessage(globalTranslations.cancel)}
        </button>
      </div>
    </div>);

}

export default SearchNameFilter;
